import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/preferences/menu-designer')({
  beforeLoad: () => {
    throw redirect({
      to: '/preferences/navigation-bar',
      replace: true,
    })
  },
})
